var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPortfolio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14197",
    "data-name": "Rectangle 14197",
    width: 16,
    height: 16,
    transform: "translate(4 4)",
    fill: "#000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_34",
    "data-name": "Mask Group 34",
    transform: "translate(-4 -4)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "briefcase",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53095",
    "data-name": "Group 53095"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53094",
    "data-name": "Group 53094"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65537",
    "data-name": "Path 65537",
    d: "M14.667,3.333H11.333V2.667A1.335,1.335,0,0,0,10,1.333H6A1.335,1.335,0,0,0,4.667,2.667v.667H1.333A1.335,1.335,0,0,0,0,4.667v2A1.335,1.335,0,0,0,1.333,8H6.667V7.667A.333.333,0,0,1,7,7.333H9a.333.333,0,0,1,.333.333V8h5.333A1.335,1.335,0,0,0,16,6.667v-2A1.335,1.335,0,0,0,14.667,3.333ZM10,3.333H6V2.667h4Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65538",
    "data-name": "Path 65538",
    d: "M15.815,8.36a.334.334,0,0,0-.35.033,1.316,1.316,0,0,1-.8.274H9.333v1A.333.333,0,0,1,9,10H7a.333.333,0,0,1-.333-.333v-1H1.333a1.316,1.316,0,0,1-.8-.274A.333.333,0,0,0,0,8.658v4.675a1.335,1.335,0,0,0,1.333,1.333H14.667A1.335,1.335,0,0,0,16,13.333V8.658A.333.333,0,0,0,15.815,8.36Z",
    fill: "#000"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.930632df3a5ba8847280a1d1a8629bbf.svg";
export { ForwardRef as ReactComponent };